import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import PagesController from './PagesController';

import panel from '../../services';

export default angular.module('app.page', [uirouter, panel])
    .config(routing)
    .controller('PagesController', PagesController)
    .name;


// WEBPACK FOOTER //
// ./src/app/features/pages/index.js